import Vue from 'vue'
import App from './App.vue'
import Router from 'vue-router'

import './utils/uni-h5-shim'
import router from './routers.js'
import { setH5RouterForUni } from './utils/uni-h5-shim'
setH5RouterForUni(router)

import { Toast,Overlay,Loading,Uploader,Picker,Popup,Dialog,Field,NavBar,Button } from 'vant';
import 'vant/lib/index.css';
Vue.use(Toast);
Vue.use(Overlay);
Vue.use(Loading);
Vue.use(Uploader);
Vue.use(Picker);
Vue.use(Popup);
Vue.use(Dialog);
Vue.use(Field);
Vue.use(NavBar);
Vue.use(Button);

import ElementUI from 'element-ui'
import 'normalize.css/normalize.css'
import '@/assets/styles/element-variables.scss'
Vue.use(ElementUI, { size: 'small' })


Vue.use(Router)
import '@/assets/global.less' /*引入公共样式*/
import '@/assets/uni-h5-tags.less' /* 小程序标签在浏览器中的块级布局修复 */

// 基础组件的自动化全局注册。全局注册的行为必须在根 Vue 实例 (通过 new Vue) 创建之前发生
import './components/index';




Vue.prototype.$toast=Toast



Vue.prototype.back=function () {
	if (window.history.length <= 1) {
	    this.$router.push({path:'/'})
	    return false
	} else {
	    this.$router.go(-1)
	}
}

Vue.prototype.openUrl=function (url) {
	this.$router.push({path:url})
	
}

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err)
}

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router
}).$mount('#app')
